var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9732 6.95109H3.50389L8.51465 1.80561C8.9151 1.39439 8.9151 0.719571 8.51465 0.308354C8.41966 0.210607 8.30683 0.133058 8.18261 0.0801464C8.0584 0.0272349 7.92524 0 7.79076 0C7.65628 0 7.52313 0.0272349 7.39891 0.0801464C7.2747 0.133058 7.16186 0.210607 7.06687 0.308354L0.300281 7.25687C0.205093 7.35442 0.129575 7.47028 0.0780485 7.59784C0.0265224 7.72539 0 7.86213 0 8.00022C0 8.13832 0.0265224 8.27505 0.0780485 8.40261C0.129575 8.53016 0.205093 8.64603 0.300281 8.74358L7.06687 15.6921C7.16193 15.7897 7.27479 15.8671 7.39899 15.92C7.5232 15.9728 7.65632 16 7.79076 16C7.9252 16 8.05832 15.9728 8.18253 15.92C8.30674 15.8671 8.41959 15.7897 8.51465 15.6921C8.60972 15.5945 8.68512 15.4786 8.73657 15.351C8.78802 15.2235 8.8145 15.0868 8.8145 14.9487C8.8145 14.8107 8.78802 14.674 8.73657 14.5464C8.68512 14.4189 8.60972 14.303 8.51465 14.2054L3.50389 9.0599H14.9732C15.5379 9.0599 16 8.58542 16 8.0055C16 7.42557 15.5379 6.95109 14.9732 6.95109Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/backArrow.a1f7247f.svg";
export { ForwardRef as ReactComponent };